<template>
	<Transition name="fade">
		<div v-if="!loading">
			<p v-if="isOverviewPage" class="text-xl font-semibold pl-2.5 mb-2.5 xl:pl-0">
        Historia - {{ leagueId === '4' ? 'Euro' : leagueName }}
      </p>
		  <div class="border border-zt-light rounded-zt grid grid-cols-[1fr_max-content] bg-zt-light/35">
		    <div class="contents text-xs uppercase font-medium [&>*]:border-b [&>*]:border-zt-light [&>*]:bg-zt-light-full [&>*]:h-[38px] [&>*]:flex [&>*]:items-center">
		      <p class="pl-2.5">Sezon</p>
		      <p class="">Zwycięzca</p>
		    </div>
        <div v-for="(data, index) in filteredHistory" :key="data.season" class="items-center text-[13px] contents
		      [&>*]:items-center [&>*]:h-[38px] [&>*]:flex [&>*]:border-zt-light [&>*]:border-b [&:last-child>*]:border-b-0">
          <div class="px-2.5">
            <div class="line-clamp-1 text-ellipsis break-all pointer-event-none font-light opacity-70"
                 :class="{'zt-hover underline cursor-pointer !opacity-100 !pointer-event': data.has_history_table}"
                 @click="openSeasonTableModal(data)" data-count-click="LIGA ➝ HISTORIA (oraz przegląd➝historia)" data-count-click-category="football">
              {{ getLeagueInfo(data) }}
            </div>
          </div>
          <div class="[&>*]:flex [&>*]:gap-x-[5px] flex justify-between">
            <a v-if="(data.league_id === '4' || (data.team_query_name !== null)) && !isURepresentation"
               :href="!teamOnlyInCup(data.team_id) ? `/wyniki-pilka-nozna/druzyny/${data.team_query_name}/` : null"
               class="no-default-style w-[168px] max-w-[168px] mr-2.5 xl:max-w-[194px] xl:w-[194px]"
               :class="{ 'zt-hover': !teamOnlyInCup(data.team_id), '!w-[125px] !max-w-[125px] xl:!w-[145px] xl:!max-w-[145px]' : hasOdds, 'font-light' : leagueId === '39' || leagueId === '106' }">
              <img class="w-5 h-5 object-contain"
                   :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${data.team_query_name}.png`"
                   width="20" height="20" :alt="data.team_name" />
              <div class="text-ellipsis break-all line-clamp-1"
                   :class="{ 'max-w-[120px] xl:!max-w-[140px]' : hasOdds && getOdds(+data.season) }">
                {{ getTeamName(data) }}{{ data.league_id === '480' ? ' OL.' : '' }}
              </div>
            </a>
            <div v-else class="w-[168px] max-w-[168px] mr-2.5 xl:max-w-[194px] xl:w-[194px]">
              <img v-if="data.team_id === '99999'" class="w-5 h-5 object-contain"
                   :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/herfolge.png`"
                   :alt="data.team_name" width="20" height="20" />
              <img v-else-if="data.team_id !== '0' && data.team_query_name" class="w-5 h-5 object-contain"
                   :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${data.team_query_name}.png`"
                   :alt="data.team_name" width="20" height="20" />
              <img v-else class="w-5 h-5 object-contain"
                   :src="`/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg`"
                   :alt="data.team_name" width="20" height="20">
              <div class="text-ellipsis break-all line-clamp-1">
                {{ data.team_short_name && data.team_short_name !== '' ? data.team_short_name : data.team_name }}
                {{ data.league_id === '480' ? ' OL.' : '' }}
              </div>
            </div>
            <div v-if="hasOdds && getOdds(+data.season)"
                 data-bs-delay='{"show": 100, "hide": 400}' data-bs-toggle="tooltip" data-bs-placement="bottom"
                 title="Kursy bukmacherskie na wygraną (przed rozpoczęciem rozgrywek)"
                 class="text-[10px] cursor-pointer w-[37px] h-[19px] flex justify-center items-center font-normal border border-zt-light rounded-zt mr-[6px] xl:mx-[6px]">
              {{ formatOddsValue(getOdds(+data.season)) }}
            </div>
          </div>

        </div>
		    <div v-if="isOverviewPage && amount < winners.length"
             class="py-4 col-span-2 border-zt-light flex items-center justify-center text-zt-more text-xs uppercase">
          <span class="text-zt-more underline zt-hover cursor-pointer" @click="amount += 10">Rozwiń</span>
		    </div>
        <div v-if="!isOverviewPage && amount < winners.length"
             class="py-4 col-span-2 border-zt-light flex items-center justify-center text-zt-more text-xs uppercase">
          <span class="text-zt-more underline zt-hover cursor-pointer" @click="amount += 1000">Rozwiń wszystkie</span>
        </div>
		  </div>
			<div v-if="+leagueId === 4 && !isOverviewPage">
				<LeagueScorerHistory :league-id="+leagueId" :league-name="leagueName" />
			</div>
      <div v-if="openModal">
        <Transition name="fade">
          <div class="fixed w-full h-full top-0 left-0 rounded-md z-backdrop bg-black/40">
            <div class="mx-auto fixed bg-zt-normal shadow-zt w-full flex flex-col z-modal
                        xl:rounded-md xl:h-[524px] xl:!relative xl:max-w-[624px]"
                 :class="[window.PHP.visibleAdminBar ? 'top-8 h-[calc(100%_-_32px)] xl:top-[112px]' : 'top-0 h-full xl:top-[80px]']"
                 style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)" v-click-outside="clickOutside">
              <div class="p-4 !pr-14">
                <span class="font-semibold">
                  ARCHIWUM:
                  {{ selectedSeason.league_name }}
                  {{ seasonsType === 'year' ? (+leagueId === 556 ? selectedSeason.season + 1 : selectedSeason.season)
                    : `${selectedSeason.season}/${(+selectedSeason.season + 1).toString().slice(2, 4)}` }}
                </span>
                <div class="x-close-modal" @click="closeSeasonTableModal"></div>
              </div>
              <div class="w-full h-full overflow-y-scroll">
                <football-table v-if="!['Supercup', 'Cup', 'European Cup', 'National Cup'].includes(leagueType)"
                                :league-id="selectedSeason.leagueId"
                                :season="selectedSeason.season"
                                :history="true"
                                :seasons-type="seasonsType"
                                @loaded="loaded"/>
                <football-league-timetable v-else
                                           :leagueId="selectedSeason.leagueId"
                                           :season="selectedSeason.season"
                                           :leagueType="leagueType"
                                           :countryQueryName="selectedSeason.country_query_name"
                                           :countryName="selectedSeason.country_name"
                                           :leagueName="selectedSeason.league_name"
                                           :history="true" show-promotion-icon
                                            @loaded="loaded"/>
                <div v-if="modalLoaded" class="zt-button shrink-0 !bg-zt-light w-full max-w-[360px] mx-auto my-4 text-center cursor-pointer zt-hover"
                     @click="closeSeasonTableModal">
                  ZAMKNIJ OKNO
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
      <div v-if="leagueWinOdds?.length > 0 && !isOverviewPage" class="pt-4">
        <span class="text-xl font-semibold pl-2.5 xl:pl-0">Kursy na wygranie rozgrywek</span>
        <div class="flex items-center mt-1.5 pl-2.5 text-[11px] font-medium
        bg-zt-light-full h-[38px] uppercase border border-zt-light rounded-t-zt">
          Drużyna
        </div>
        <div class="flex items-center pl-2.5 uppercase text-xs text-zt-more font-medium
        bg-zt-light-full h-[35px] border border-t-0 border-zt-light">
          Kursy przed rozpoczęciem rozgrywek
        </div>
        <div :key="team.team_id" v-for="team in leagueWinOdds" class="h-[38px] bg-zt-light/35 last:rounded-b-zt pl-2.5 pr-3 flex items-center justify-between border-x border-b border-zt-light">
          <a :href="`/wyniki-pilka-nozna/druzyny/${team.query_name}`" class="no-default-style zt-hover flex items-center gap-x-[5px]">
            <img class="w-5 h-5 min-w-5 min-h-5 object-contain aspect-square" :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${team.query_name}.png`"
            @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
            :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
            <span class="text-ellipsis break-all line-clamp-1 text-[13px] font-normal">
              {{ team.short_name !== '' ? team.short_name : team.name }}
            </span>
          </a>
          <div class="w-[37px] h-[21px] border grid place-items-center border-zt-light  rounded-zt">
            <span class="text-[10px] opacity-70"> {{ formatOddsValue(team.odds) }} </span>
          </div>
        </div>

      </div>
		</div>
	</Transition>
</template>

<script>
import { leagueWinnersOdds } from '../../../../assets/js/league-winners-odds';
import LeagueScorerHistory from "./LeagueScorerHistory.vue";
import footballTable from "../../../sections/FootballTable.vue";
import utils_mixin from "../../../mixins/utils_mixin";
import FootballLeagueTimetable from '../../../sections/FootballLeagueTimetable.vue';
export default {
	name: 'LeagueHistory',
	components: { FootballLeagueTimetable, LeagueScorerHistory, footballTable},
  props: ['seasonsType'],
	inject: ['WP'],
  mixins: [utils_mixin],
	data() {
		return {
			winners: [],
			amount: 5,
      teamIds: [],
			loading: true,
      openModal: false,
      selectedSeason: {
        leagueId: 0,
        season: 0,
        country_query_name: '',
        league_query_name: '',
        country_name: '',
        league_name: ''
      },
      clickOutside: {
        handler: (e) => {
          if (!e.target.closest('.preventCloseParentModal')) {
            this.closeSeasonTableModal(e);
          }
        },
        events: ['touchend', 'mousedown']
      },
			tournamentIds: [5, 100012, 100011, 6, 100009, 4, 9, 913, 22, 100005],
      leagueWinOdds: [],
      modalLoaded: false,
		}
	},
	computed: {
    hasOdds() {
      return leagueWinnersOdds.hasOwnProperty(+this.leagueId);
    },
		isOverviewPage() {
			if (!this.$attrs.isOverview) {
				return false;
			}
			return this.$attrs.isOverview === 'true';
		},
		filteredHistory() {
			let winners = this.winners;
      winners = winners.slice(0, this.amount);
			return winners;
		},
		leagueId() {
			return this.$attrs.leagueId;
		},
		leagueName() {
			return this.$attrs.leagueName;
		},
    isURepresentation() {
      return /U(18|19|20|21)/.test(this.$attrs.leagueName);
    },
    leagueType() {
      return this.$attrs.leagueType ?? '';
    }
	},
  async mounted() {
    if (!this.isOverviewPage) {
      this.amount = 10;
    }
    const resWinners = await axios.post(this.WP.ajaxUrl, {
      endpoint: 'api_get_league_winners_history',
      league_id: this.leagueId,
    })
    const resOdds = await axios.post(this.WP.ajaxUrl, {
      endpoint: 'api_get_league_win_odds',
      league_id: this.leagueId,
    })
	  this.winners = resWinners.data.data;
    this.leagueWinOdds = resOdds.data.data;
    await this.getTeams();
		this.loading = false;
    this.removePlaceholder(this.$attrs.component);
  },
	methods: {
    getOdds(year) {
      if (!this.hasOdds) {
        return 0;
      }
      return leagueWinnersOdds[+this.leagueId][year];
    },
		getLeagueInfo(data) {
			let leagueName = data.league_id === '4'? 'Euro' : data.league_name;
			let season = data.season;
			let specialCase = data.league_id === '4' && data.season === '2020'? ' (2021)' : '';
      if (this.seasonsType === 'year') {
        if (data.league_id === '100005') {
          return `${data.season}${specialCase} Mundial`;
        } else {
          return `${data.season}${specialCase} ${leagueName} `;
        }
      }
			return `${season}/${(+data.season + 1).toString().slice(2, 4)}${specialCase} ${leagueName}`;
		},
    formatOddsValue(value) {
      value = parseFloat(value);
      if (value >= 1000) {
        return '999+';
      }
      if (value < 10) {
        return value.toFixed(2)
      }
      if (value >= 10) {
        return value.toFixed(1);
      }
    },
		getTeamName(team) {
			if (team.team_short_name !== '') {
				return team.team_short_name;
			}
			if (team.team_full_name !== '') {
				return team.team_full_name;
			}
			return team.team_name;
		},
    async getTeams() {
      let res = [];
      if (this.tournamentIds.includes(+this.leagueId)) {
        res = await axios.post(this.WP.ajaxUrl, {
          endpoint: 'api_get_football_national_teams',
        })
      } else {
        res = await axios.post(this.WP.ajaxUrl, {
          endpoint: 'api_get_football_teams',
        })
      }
	    this.teamIds = res.data.data.map(team => Number(team.team_id));
    },
    teamOnlyInCup(teamId) {
      return !this.teamIds.includes(Number(teamId));
    },
    openSeasonTableModal(team) {
      if (team.has_history_table) {
        this.blockScrolling();
        this.selectedSeason.leagueId = +team.league_id;
        this.selectedSeason.season = +team.league_id === 556 ? +team.season - 1 : +team.season;
        this.selectedSeason.country_query_name = team.country_query_name;
        this.selectedSeason.league_query_name = team.league_query_name;
        this.selectedSeason.country_name = team.country_name;
        this.selectedSeason.league_name = team.league_name;
        this.openModal = true;
      }
    },
    closeSeasonTableModal() {
      if (this.openModal) {
        this.selectedSeason.leagueId = 0;
        this.selectedSeason.season = 0;
        this.selectedSeason.country_query_name = '';
        this.selectedSeason.league_query_name = '';
        this.selectedSeason.country_name = '';
        this.selectedSeason.league_name = '';
        this.unblockScrolling();
        this.openModal = false;
        this.modalLoaded = false;
      }
    },
    loaded() {
      this.modalLoaded = true;
    }
	},
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: all 0.5s ease;

}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>